import { useEffect, useState } from "react";

// Smart number-input behaviour: select-all on focus, allow transient empty
// while typing, clamp to min/max, fall back to a default on blur.
export const useEditableNumber = (value, onChange, { min, max, fallback = 0, allowEmpty = false } = {}) => {
  const [text, setText] = useState(String(value ?? ""));
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (!focused) setText(String(value ?? ""));
  }, [value, focused]);

  const clamp = (n) => {
    let v = n;
    if (typeof min === "number" && v < min) v = min;
    if (typeof max === "number" && v > max) v = max;
    return v;
  };

  const onTextChange = (e) => {
    const raw = e.target.value;
    setText(raw);
    if (raw === "") { if (allowEmpty) onChange(""); return; }
    if (raw === "-" || raw === ".") return;
    const n = Number(raw);
    if (Number.isNaN(n)) return;
    onChange(clamp(n));
  };

  const onFocus = (e) => {
    setFocused(true);
    e.target.select();
  };

  const onBlur = () => {
    setFocused(false);
    if (text === "") {
      if (allowEmpty) { onChange(""); return; }
      setText(String(fallback));
      onChange(clamp(fallback));
      return;
    }
    if (Number.isNaN(Number(text))) {
      setText(String(fallback));
      onChange(clamp(fallback));
    }
  };

  return {
    displayValue: focused ? text : String(value ?? ""),
    inputProps: { onChange: onTextChange, onFocus, onBlur },
  };
};
